<!-- <div class="page_loader"></div>

<div class="login-26" style="direction: ltr;">
    <div id="particles-js"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 align-items-center">
                <div class="form-section">
                    <div class="logo-2">
                        <a href="/">
                            <img style="height:100px;margin:auto" src="assets/img/ejada.png" alt="logo">
                        </a>
                    </div>
                    <div class="main-title">
                        <h3 class="headline">
                            <span>Sign Into</span>
                            <span class="ms-1 me-1 words-wrapper">
                                <b class="visible">Your Account</b>
                                <b class="blue">Your Account</b>
                            </span>
                        </h3>
                    </div>

                    <form (ngSubmit)="send()" [formGroup]="form">
                        <div class="form-group clearfix">
                            <input formControlName="email" type="email" class="form-control" [placeholder]="'Email / Username'" aria-label="Email Address">
                            <mat-error *ngIf="f.email.touched && form.get('email').hasError('required')">We need an email/username to log you in</mat-error>
                        </div>
                        <div class="form-group clearfix">
                            <input formControlName="password" type="password" class="form-control" autocomplete="off" [placeholder]="'Password'" aria-label="Password">
                            <mat-error *ngIf="f.password.touched && form.get('password').hasError('required')">{{"We need a password to log you in"}}</mat-error>

                        </div>
                        <div class="form-group">
                            <div class="form-check d-flex">
                                <input class="form-check-input" type="checkbox" id="rememberme">
                                <label style="margin:0 30px" class="form-check-label" for="rememberme">
                                    {{"Remember me"}}
                                </label>
                            </div>
                        </div>
                        <div class="flex-1" style="display:none">
                          <input #token id="token">
                        </div>
                        <div class="form-group mb-0 clearfix">
                            <button type="submit" class="btn btn-lg btn-primary btn-theme">{{"Login"}}</button>
                        </div>
                        <div class="extra-login clearfix">
                           
                        </div>
                        <div class="clearfix"></div>
                    </form>

					
					    <div style="margin-top:25px;" class="logo-2">
                        <a>
                            <img style="height:65px;margin:auto" src="assets/img/logo.png" alt="logo">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="w-full h-screen bg-pattern flex flex-col items-center justify-center">
    <div @fadeInUp class="card overflow-hidden w-full max-w-md">
      <div class="p-6 pb-0 flex flex-col items-center justify-center">
        <div class="fill-current text-center">
          <img class="w-[9rem]" src="assets/img/towa_logo.png" />
        </div>
      </div>
  
      <div class="text-center mt-4">
        <h2 class="title m-0">{{ WELCOME_BACK}}</h2>
        <h4 class="body-2 text-secondary m-0">
          {{WELCOME_BACK_MESSAGE}}
          <p class="text-red-500 mb-2" *ngIf="error | async">{{error | async}}</p>
        </h4>
      </div>
  
      <div [formGroup]="form" class="p-6 flex flex-col gap-4">
        <div class="flex flex-col">
          <mat-form-field class="flex-1">
            <mat-label>{{EMail}}</mat-label>
            <input formControlName="email" matInput required />
            <mat-error *ngIf="form.controls.email.hasError('required')"
            >{{EMAIL_REQUIRED}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>{{Password}}</mat-label>
            <input
              [type]="inputType"
              formControlName="password"
              matInput
              required />
            <button
              (click)="toggleVisibility()"
              mat-icon-button
              matIconSuffix
              matTooltip="Toggle Visibility"
              type="button">
              <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
              <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
            </button>
            <mat-hint>{{EYE_VISIBILITY}}</mat-hint>
            <mat-error *ngIf="form.controls.password.hasError('required')"
            >{{PASSWORD_REQUIRED}}
            </mat-error>
          </mat-form-field>
        </div>
  
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <mat-checkbox color="primary">{{REMEMBER_ME}}</mat-checkbox>
          <a [routerLink]="['/forgot-password']" style="font-size: 12px; text-decoration: underline;">{{FORGET_PASSWORD}}</a>
        </div>

        <div class="flex-1" style="display:none">
            <input #token id="token">
          </div>
        <button (click)="send()" color="primary" mat-raised-button type="button">
          {{SIGNIN}}
        </button>
  
 
      </div>
    </div>
  </div>
  